import { combineReducers } from "redux";

import { ACTIONS, ActionType } from "actions/collection/types";
import { SearchResults, SearchOptions } from "./types";

const initialSearchResults = {
    loading: false,
    loadingMore: false,
    results: null,
};

const initialSearchOptions = {
    queryObj: null,
};

export const initialState = {
    searchOptions: initialSearchOptions,
    searchResults: initialSearchResults,
};

const searchOptions = (state: SearchOptions = initialSearchOptions, action: ActionType) => {
    if (action.type === ACTIONS.SET_SEARCH_QUERY) {
        return {
            queryObj: action.queryObj,
        };
    }
    return state;
};

const searchResults = (state: SearchResults = initialSearchResults, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.SEARCH_REQUEST:
            return {
                ...state,
                results: null,
                loading: true,
            };
        case ACTIONS.SEARCH_SUCCESS: {
            return {
                ...state,
                loading: false,
                results: action.payload,
            };
        }
        case ACTIONS.SEARCH_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case ACTIONS.SEARCH_MORE_REQUEST:
            return {
                ...state,
                loadingMore: true,
            };
        case ACTIONS.SEARCH_MORE_SUCCESS: {
            const data = state.results?.data || [];
            return {
                ...state,
                loadingMore: false,
                results: {
                    ...action.payload,
                    data: [...data, ...action.payload.data],
                },
            };
        }
        case ACTIONS.SEARCH_MORE_FAILURE:
            return {
                ...state,
                loadingMore: false,
            };
        default:
            return state;
    }
};

export default combineReducers({
    searchOptions,
    searchResults,
});
